module.exports = __webpack_public_path__ + "img/caret-down.27e86c91.svg";